import { Router } from '@angular/router';
import { MessageService, SelectItem } from 'primeng/api';
import { Component, OnDestroy, ViewChild, HostListener, OnInit, AfterViewInit, Input, ElementRef, ViewEncapsulation } from '@angular/core';
import { AppComponent } from '../../../../../app.component';
import { AppMainComponent } from '../main-panel/app.main.component';
import { UserDetails, AuthService, StorageService, DialogService } from '../../../../../air/modules/common/service';
import { CommonService } from '../../../common/service/common/common.service'
import { SubSink } from 'subsink';
import { OverlayPanel } from 'primeng/overlaypanel';
import { MenuItem } from 'primeng/api';
import { UserSetting } from '../../../../../air/modules/common/lib/types/general';
import moment from 'moment';
import { UserControlService } from '../../../../../air/modules/common/service/userControl/user-control.service';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { TieredMenu } from 'primeng/tieredmenu';
import { withLatestFrom } from 'rxjs';
import { FilterService } from '../../service/filter/filter.service';
import { AirAppRoutes } from '../../lib/air-api-constant';
import { Popover } from 'primeng/popover';
import { ISelectedFilters, IFiltersCriteria, EmptyFilters } from '../../lib/types/selectedFilters';
@Component({
    selector: 'air-app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    standalone: false,
     //encapsulation: ViewEncapsulation.None
})
export class AppTopBarComponent implements OnDestroy, OnInit, AfterViewInit {
    @ViewChild('multiSelectDropdown') multiSelectDropdown: MultiSelect;
    @ViewChild('tieredMenu') tieredMenu: TieredMenu;
    @ViewChild('op') alertPopUp: Popover;
    @ViewChild('multiSelectDropdown') multiSelect: MultiSelect;
    @ViewChild('multiSelectDropdown', { read: ElementRef }) multiSelectElement: ElementRef;
    private reloadCount = 0;
    private maxReloads = 1;
    reference: SelectItem[];
    companyModel: any = [];
    showProgressBar: boolean = false;
    companies: any = [];
    // airCompanies: boolean = true;
    selectedCompanyCode: any;
    userDetails: any = {};
    display: boolean = false;
    private subscription = new SubSink();
    preDeparture: any[] = [];
    inTransit: any[] = [];
    postArrival: any[] = [];
    private selectedGlobalFilter: ISelectedFilters = {} as ISelectedFilters;
    selectedDrop: SelectItem;
    notificationVisibility: boolean = false;
    isAlertFetch: boolean = false;
    alertIndex: number = 0;
    userName: any;
    isPanelCloseAllowed = true;
    // inTransitInitialLength: number;
    // preDepartureInitialLength: number;
    // alertListMismatchCount: number;
    selectedCompanies: any = [];
    // alertListMismatchCountPreDeparture: number;
    // alertCounts: any = {
    //     inTransit: 0,
    //     postArrival: 0,
    //     preDeparture: 0,
    //     totalNewAlert: 0
    // }
    // valueOfNewAlerts: any;
    // unReadAlertCount: number = 0;
    // showRealAllNotification: boolean = false;
    // lastAlertOpenTime: string;
    AppRoutes: any;
    isCompanyDropdownDisabled: boolean;


    selectedCompanyCodes: any[] = [];
    companyDropdownSelected: boolean = false;
    selectedItemsLabel: string = 'All Companies';
    downloadManualItems: any;
    topbarMenuItems: any[] = [];
    @Input() showAirDisplay: boolean = true;
    showButton: boolean = false;
    logoLink: string = '/';
    logoSrc: string = 'assets/layout/images/Smart Navigator_White.png';
    logoClass: string = 'bdp-logo';
    userEmail: string = '';

    @HostListener('window:click', ['$event'])
    handleKeyDown(event: any) {
        const filterElem = document.getElementById('notificationList');
        const filterElemIcon = document.getElementById('bdpNotificationIcon');
        if (filterElem) {
            if (filterElem.contains(event.target) || (filterElemIcon && filterElemIcon.contains(event.target)) || event.target.classList.contains('bdp-notification-badge')) {
                // Clicked in box
            } else {
                this.notificationVisibility = false;
            }
        }
    }


    constructor(public appMain: AppMainComponent,
        public app: AppComponent,
        private filterService: FilterService,
        private authService: AuthService,
        private storageService: StorageService,
        private commonService: CommonService,
        private router: Router,
        private userControlService: UserControlService,
        private messageService: MessageService,
        private dialogService: DialogService,

    ) {
        this.subscription.add(
            this.filterService.$filterSelection
                .pipe(withLatestFrom(this.commonService.showAirDisplay$))
                .subscribe(([filter, showAir]) => {
                    if (showAir !== null) {
                        this.showAirDisplay = showAir;
                    }

                    if (filter && this.showAirDisplay) {
                        const airFilterSelected: IFiltersCriteria = this.filterService.getIds(filter);
                        this.selectedGlobalFilter = JSON.parse(JSON.stringify(airFilterSelected)); // Efficient shallow copy
                    }

                    this.selectedCompanyCode = this.selectedGlobalFilter?.companies?.[0] || null;
                })
        );

        this.preDeparture = [];
        this.inTransit = [];
        this.postArrival = [];
        const user = storageService.getItem("user");
        const email = storageService.getItem("email");
        this.userEmail = email;
        //  this.userName = UserSetting.userName;
        if (user) {
            this.userName = user;
        }

        // Get firstName and lastName from storage and combine them
        // const firstName = this.storageService.getItem('firstName') || '';
        // const lastName = this.storageService.getItem('lastName') || '';
        // this.userName = `${firstName} ${lastName}`.trim();
    }

    private updateProperties() {
        if (this.showAirDisplay) {
            this.logoLink = '/app/air';
            this.logoSrc = 'assets/layout/images/BDP AIR.svg';
            this.logoClass = 'bdp-logo-air';
        } else {
            this.logoLink = '/';
            this.logoSrc = 'assets/layout/images/Smart Navigator_White.png';
            this.logoClass = 'bdp-logo';
        }
    }

    companyChanged() {
       this.showAirDisplay= true;
        if (this.showAirDisplay) {
            this.selectedCompanyCode = this.selectedCompanyCodes;
        }
    }

    companySelectionClicked(event?: any): void {
        if (event) {
            event.preventDefault();
        }
        if (!this.selectedCompanyCodes || this.selectedCompanyCodes.length === 0) {
            this.messageService.add({
                key: 'emptyToster', severity: 'error', life: 10000,
                summary: 'Error Message',
                detail: 'At least 1 company should be selected.'
            });
        }
        this.companyDropdownSelected = true;
    }

    onCompanyPanelHide(event: Event) {
    //      event.preventDefault(); // Not deprecated, Typescript strict checking issue. It is still used.

        if (!this.selectedCompanyCodes || this.selectedCompanyCodes.length === 0) {
            if (this.multiSelectDropdown) {
                setTimeout(() => {
                    this.multiSelectDropdown.show();
                }, 800);
            }
        }
        else {
            this.groupChange();
        }
    }

    // onCompanyPanelOptionChange(event: Event) {
    //     if (event) {
    //         event.preventDefault();
    //     }
    //     event.stopPropagation();
    //     if (!this.selectedCompanyCodes || this.selectedCompanyCodes.length === 0) {
    //         if (this.multiSelectDropdown) {
    //             this.multiSelectDropdown.show();
    //         }
    //     }
    //     else {
    //         this.checkCompanySelection();
    //     }
    // }

    // To show error when no company is selected
    showNoCompanySelectedError() {
        this.messageService.add({
            key: 'emptyToster', severity: 'error', life: 10000,
            summary: 'Error Message',
            detail: 'At least 1 company should be selected.'
        });
    }


    public groupChange() {
        this.companyChanged();
        this.showAirDisplay = true; // Ensure showAirDisplay is true
        this.checkCompanySelection();
        if (!this.selectedCompanyCodes || this.selectedCompanyCodes.length === 0) {
            this.showNoCompanySelectedError();
        }
        else {
            let filter;
            this.companyDropdownSelected = false;
            if (this.selectedGlobalFilter) {
                filter = JSON.parse(JSON.stringify(this.selectedGlobalFilter));
            }
            else {
                filter = new EmptyFilters();
            }
            if (this.selectedCompanyCode) {
                filter = new EmptyFilters();
                if (this.selectedCompanyCode != 'all') {
                    if (this.showAirDisplay) {
                        filter.companies = this.selectedCompanyCode; // For Air, keep array as-is
                    }
                }
                if (this.showAirDisplay) {
                    this.filterService.updateFilterSelection(filter, "company");
                    this.storageService.setItem("filters", filter);
                    this.filterService.changeCompanySelection(this.selectedCompanyCode);
                }
            } else {
                filter.exception = 0;
                filter.shipmentType = 0;
                let companySelected = this.companies.find((company) => {
                    return company.id == filter.companies;
                });
                if (companySelected) {
                    this.selectedCompanyCode = companySelected.id
                }
                this.filterService.changeCompanySelection(this.selectedCompanyCode);
            }

        }
    }


    checkCompanySelection() {
        // Handle empty selection
        if (!this.selectedCompanyCodes?.length) {
            this.selectedItemsLabel = '';
            return;
        }
        // Handle single company assigned case
        if (this.companies.length === 1) {
            this.selectedItemsLabel = this.companies[0].value;
            return;
        }

        // Handle all companies selected
        const allSelected = this.selectedCompanyCodes.length === this.companies.length;
        if (allSelected) {
            this.selectedItemsLabel = 'All Companies';
            return;
        }


        // Handle 1-3 companies selected
        if (this.selectedCompanyCodes.length <= 3) {
            const selectedNames = this.companies
                .filter(company => this.selectedCompanyCodes.includes(company.id))
                .map(company => company.value);
            this.selectedItemsLabel = selectedNames.join(', ');
            return;
        }

        // Handle more than 3 companies
        this.selectedItemsLabel = `${this.selectedCompanyCodes.length} companies selected`;
    }

    onCompanyPanelOptionChange(event: any) {
        this.selectedCompanyCodes = event.value;
        this.checkCompanySelection();
        this.companyChanged();
    }

    getAirCompanies() {
        this.companies = [];
        this.subscription.add(this.commonService.getAirCompany().subscribe((res: any) => {
            if (res?.data) {
                this.companies = res.data.map((company: { id: any; name: string, groupCode: any }) => ({
                    companyid: company.id,
                    value: company.name,
                    id: company.groupCode,
                }));

                // Select all companies by default
                this.selectedCompanyCodes = this.companies.map(company => company.id);
                this.checkCompanySelection();

                // Update services and storage
                this.storageService.setItem('companies', this.companies);
                this.filterService.updateAssignedCompanies(this.companies);

                this.isCompanyDropdownDisabled = this.companies.length <= 1;

                if (this.selectedGlobalFilter) {
                    this.handleFilters();
                } else {
                    this.companyChanged();
                }
            }
        }));
    }
    private handleFilters() {
        this.companyChanged();
        this.selectedGlobalFilter.companies = this.selectedCompanyCode;
        const filter = JSON.parse(JSON.stringify(this.selectedGlobalFilter));
        this.filterService.updateFilterSelection(filter, "GetCompanies");
        this.storageService.setItem("filters", filter);
        this.filterService.changeCompanySelection(this.selectedCompanyCode);
        this.storageService.setItem("defaultFilters", filter);
    }

    goToTrackingDetails(item) {
        this.commonService.navigateRoute({
            route: AirAppRoutes.User.TRACKING_LIST_DETAILS,
            type: 'User',
            routeData: item.shipmentId
        });
    }


    navigateToAirProfile(route: string) {
        this.appMain.onTopbarAirSubItemClick(event, route);
    }

    ngAfterViewInit(): void {


    }

    ngOnInit() {
        this.showAirDisplay = true;
        this.updateProperties();
        if (!this.companies.length) {
            this.getAirCompanies();
        }
        this.initializeAirMenuItems();
    }

    initializeAirMenuItems() {
        this.downloadManualItems = [
            // {
            //     label: 'My Account',
            //     icon: 'pi pi-user',
            //     styleClass: 'menu-item',
            //     command: () => this.navigateToAirProfile(AirAppRoutes.User.PROFILE)
            // },
            // {
            //     label: 'Change Password',
            //     icon: 'pi pi-key',
            //     styleClass: 'menu-item',
            //     command: () => this.navigateToAirProfile(AirAppRoutes.User.CHANGE_PASSWORD)
            // },
            {
                label: 'ETA Settings',
                icon: 'fal fa-cog',
                styleClass: 'menu-item',
                command: () => this.navigateToAirProfile(AirAppRoutes.User.ETA_THRESHOLD)
            },
            {
                label: 'Key Reference Number',
                icon: 'far fa-asterisk',
                styleClass: 'menu-item',
                command: () => this.navigateToAirProfile(AirAppRoutes.User.KEY_REFERENCE)
            },
            // {
            //     label: 'Download Manual',
            //     icon: 'pi pi-cloud-download',
            //     items: [
            //         {
            //             label: 'Customer Manual Download',
            //             icon: 'pi pi-user',
            //             command: () => this.onAirMenuItemClick('download')
            //         },
            //         {
            //             label: 'FAQ\'s',
            //             icon: 'pi pi-question-circle',
            //             styleClass: 'disabled-menu'
            //         }
            //     ]
            // },
            // {
            //     label: 'Release Notes',
            //     icon: 'fa-light fa-file-lines',
            //     styleClass: 'menu-item',
            //     command: () => this.navigateToAirProfile(AirAppRoutes.User.RELEASE_NOTES)
            // },
            {
                label: 'Sign Out',
                icon: 'pi pi-power-off',
                styleClass: 'menu-item',
                command: () => {
            
                    this.dialogService.showDialog({
                        type: 'confirm',
                        visibility: true,
                        width: '550px',
                        header: 'Sign Out Warning',
                        body: `Are you sure you want to Sign Out?<br/><br/>
                                   Signing out will automatically close any other Smart Suite application that you have signed into via Single Sign In.`,
                        action: 'Sign Out',
                        reject: 'Stay Signed On',
                        onAccept: () => {
                        //    console.log('Sign Out accepted'); 
                            this.authService.logoutRedirect();
                        },
                        onReject: () => {
                          
                        }
                    });
                }

            }
        ];
    }

    onAirMenuItemClick(menu: string) {
        if (menu === 'download') {
            this.commonService.getCustomerUserManual().subscribe((res: any) => {
                if (res && res.status == 200) {
                    this.openPdfInNewTab(res.data);
                }
            });
        } else if (menu === 'faq') {
            window.open('https://psabdp.com/smartsupport', '_blank');
        }
    }

    openPdfInNewTab(url: string) {
        window.open(url, '_blank');
    }

    toggleMenu(event: Event) {
        this.tieredMenu.toggle(event);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}